/* Won't Miss Garage - slide out cart drawer.
   Intercepts cart links and add-to-cart forms, talks to Shopify's AJAX cart API,
   and falls back to the normal cart page if anything goes wrong. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wmg-cart-root]');
  if (!root) return;

  var itemsEl = root.querySelector('[data-wmg-cart-items]');
  var subEl = root.querySelector('[data-wmg-cart-subtotal]');
  var checkout = root.querySelector('[data-wmg-cart-checkout]');
  var isOpen = false;

  function counts() { return document.querySelectorAll('[data-wmg-cart-count]'); }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function setOpen(v) {
    isOpen = v;
    if (v) root.hidden = false;
    requestAnimationFrame(function () { root.classList.toggle('is-open', v); });
    document.documentElement.classList.toggle('wmg-cart-open', v);
    if (!v) setTimeout(function () { if (!isOpen) root.hidden = true; }, 380);
  }

  function refresh(openAfter) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (openAfter) setOpen(true); })
      .catch(function () { if (openAfter) window.location.href = '/cart'; });
  }

  function render(cart) {
    counts().forEach(function (el) { el.textContent = cart.item_count; });
    if (subEl) subEl.textContent = money(cart.items_subtotal_price, cart.currency);
    itemsEl.innerHTML = '';
    if (!cart.items.length) {
      var p = document.createElement('p');
      p.className = 'wmg-cartdrawer__empty';
      p.textContent = 'Your cart is empty.';
      itemsEl.appendChild(p);
      if (checkout) checkout.disabled = true;
      return;
    }
    if (checkout) checkout.disabled = false;

    cart.items.forEach(function (it, idx) {
      var line = idx + 1;
      var row = document.createElement('div');
      row.className = 'wmg-cartdrawer__item';

      var img = document.createElement('img');
      img.className = 'wmg-cartdrawer__img';
      img.loading = 'lazy';
      img.alt = '';
      if (it.image) img.src = it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_200x$1$2');
      row.appendChild(img);

      var mid = document.createElement('div');
      mid.className = 'wmg-cartdrawer__meta';
      var a = document.createElement('a');
      a.href = it.url; a.textContent = it.product_title;
      mid.appendChild(a);
      if (it.variant_title && it.variant_title !== 'Default Title') {
        var vt = document.createElement('small'); vt.textContent = it.variant_title; mid.appendChild(vt);
      }
      var qty = document.createElement('div');
      qty.className = 'wmg-cartdrawer__qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Decrease quantity');
      var num = document.createElement('span'); num.textContent = it.quantity;
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Increase quantity');
      minus.addEventListener('click', function () { change(line, it.quantity - 1); });
      plus.addEventListener('click', function () { change(line, it.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      mid.appendChild(qty);
      row.appendChild(mid);

      var right = document.createElement('div');
      right.className = 'wmg-cartdrawer__right';
      var price = document.createElement('strong');
      price.textContent = money(it.final_line_price, cart.currency);
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'wmg-cartdrawer__rm'; rm.textContent = 'Remove';
      rm.addEventListener('click', function () { change(line, 0); });
      right.appendChild(price); right.appendChild(rm);
      row.appendChild(right);

      itemsEl.appendChild(row);
    });
  }

  function change(line, quantity) {
    itemsEl.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { itemsEl.classList.remove('is-busy'); render(cart); })
      .catch(function () { itemsEl.classList.remove('is-busy'); refresh(false); });
  }

  // Cart links open the drawer (the drawer's own "View cart" link is exempt).
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('data-wmg-cart-page')) return;
    var u;
    try { u = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (u.origin !== window.location.origin) return;
    if (u.pathname.replace(/\/+$/, '') === '/cart') {
      e.preventDefault();
      refresh(true);
    }
  });

  root.querySelectorAll('[data-wmg-cart-close]').forEach(function (el) {
    el.addEventListener('click', function () { setOpen(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) setOpen(false); });
  if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });

  // AJAX add to cart from any product form, then pop the drawer.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"], input[type="submit"]');
    var oldLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = oldLabel; }
        if (!res.ok) {
          window.alert((res.d && (res.d.description || res.d.message)) || 'Could not add that to the cart.');
          return;
        }
        refresh(true);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = oldLabel; }
        f.submit();
      });
  }, true);

  refresh(false);
})();
